import { ApiV4LinkFinder } from './types'

export const findApiV4Link: ApiV4LinkFinder = ({ ofObject, withRel }) => {
  const links = ofObject.links || [],
    link = links.find((link) => link.rel === withRel)
  return link && link.href
}
